module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Habsburg_AG-4e8dc49f3201dd5424faa573b703c0e3.svg";